import script from "./TrainingPlanShow.vue?vue&type=script&setup=true&lang=js"
export * from "./TrainingPlanShow.vue?vue&type=script&setup=true&lang=js"

import "./TrainingPlanShow.vue?vue&type=style&index=0&id=3dd0d8ba&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Utilizador\\Desktop\\projetos\\owlpharma-hrm\\src\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3dd0d8ba"]])

export default __exports__